<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Update Profile</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>First Name:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="first_name"
                v-model="userDescription.first_name"
                v-validate="'required'"
                data-vv-as="First Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('first_name')"
              >{{ errors.first("first_name") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Surname:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="surname"
                v-model="userDescription.surname"
                v-validate="'required'"
                data-vv-as="Surname"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('surname')"
              >{{ errors.first("surname") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Job Role:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="job_role"
                v-model="userDescription.job_role"
                data-vv-as="Job Role"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Desk Phone:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="desk_phone"
                v-model="userDescription.desk_phone"
                data-vv-as="Desk Phone"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('desk_phone')"
              >{{ errors.first("desk_phone") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Softphone:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="softphone"
                v-model="userDescription.softphone"
                data-vv-as="Softphone"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('softphone')"
              >{{ errors.first("softphone") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Mobile No.:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="mobile_no"
                v-model="userDescription.mobile_no"
                data-vv-as="Mobile No."
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('mobile_no')"
              >{{ errors.first("mobile_no") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Alternate Phone 1:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="alternate_phone_1"
                v-model="userDescription.alternate_phone_1"
                data-vv-as="Alternate Phone 1"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('alternate_phone_1')"
              >{{ errors.first("alternate_phone_1") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Alternate Phone 2:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="alternate_phone_2"
                v-model="userDescription.alternate_phone_2"
                data-vv-as="Alternate Phone 2"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('alternate_phone_2')"
              >{{ errors.first("alternate_phone_2") }}</span
            >
          </vs-col>
          <!-- <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Role:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <v-select
                disabled
                v-validate="'required'"
                required
                name="role"
                label="role"
                :options="elomarkRoleTypes"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="userDescription.role"
                data-vv-as="User Role"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('role')"
              >{{ errors.first("role") }}</span
            >
          </vs-col> -->
          <template v-if="is_client == 'n'">
            <!-- <vs-col vs-type="flex" vs-w="6" class="mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Manager:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <v-select
                  disabled
                  label="full_name"
                  :options="elomarkManagers"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="userDescription.selected_manager"
                />
              </div>
            </vs-col> -->

            <vs-col vs-type="flex" vs-w="6" class="mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Address 1:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  name="address_1"
                  v-model="userDescription.address_1"
                  data-vv-as="Address 1"
                />
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-w="6" class="mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Address 2:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  name="address_2"
                  v-model="userDescription.address_2"
                  data-vv-as="Address 2"
                />
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-w="6" class="mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Address 3:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  name="address_3"
                  v-model="userDescription.address_3"
                  data-vv-as="Address 3"
                />
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-w="6" class="mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>City:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  name="city"
                  v-model="userDescription.city"
                  data-vv-as="City"
                />
              </div>
            </vs-col>

            <vs-col vs-type="flex" vs-w="6" class="mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>County:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  name="county"
                  v-model="userDescription.county"
                  data-vv-as="County"
                />
              </div>
            </vs-col>

            <vs-col vs-type="flex" vs-w="6" class="mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Country:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full mr-10">
                <AccountAutocomplete
                  class="searchbox"
                  :list="getCountries"
                  :searchOn="'head_office_country'"
                ></AccountAutocomplete>
              </div>
              {{ countryName }}
            </vs-col>

            <vs-col vs-type="flex" vs-w="6" class="mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Postcode:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  name="postcode"
                  v-model="userDescription.postcode"
                  data-vv-as="postcode"
                />
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-w="6" class="mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Rate:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  :disabled="'disabled'"
                  class="w-full"
                  name="rate"
                  v-model="userDescription.rate"
                  data-vv-as="rate"
                  v-validate="'required'"
                />
              </div>
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('rate')"
                >{{ errors.first("rate") }}</span
              >
            </vs-col>
            <vs-col vs-type="flex" vs-w="6" class="mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Date Of Birth:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <flat-pickr
                  class="flat-pick"
                  :config="configdateTimePicker"
                  v-model="userDescription.dob"
                  v-validate="'required'"
                />
              </div>
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('dob')"
                >{{ errors.first("dob") }}</span
              >
            </vs-col>
            <vs-col vs-type="flex" vs-w="6" class="mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Contract Start Date:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <flat-pickr
                  class="flat-pick ml-10"
                  :disabled="'disabled'"
                  :config="configdateTimePicker"
                  v-model="userDescription.contract_commencement_date"
                  v-validate="'required'"
                />
              </div>
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('contract_commencement_date')"
                >{{ errors.first("contract_commencement_date") }}</span
              >
            </vs-col>
            <vs-col vs-type="flex" vs-w="6" class="mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Timezone:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <TimezoneAutocomplete
                  class="searchbox mb-5"
                  :list="getTimezones"
                  :searchOn="'timezone'"
                  @event-name="handleTimeZoneSelected"
                ></TimezoneAutocomplete>
                {{ timeZoneName }}
              </div>

              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('timezone')"
                >{{ errors.first("timezone") }}</span
              >
            </vs-col>
            <!-- <vs-col vs-type="flex" vs-w="6" class="mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>User Type:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <v-select
                  disabled
                  name="user_type"
                  label="usertype"
                  :options="allUserTypes"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="userDescription.user_type"
                  v-validate="'required'"
                  data-vv-as="User Type"
                />
                <div
                  class="mt-5"
                  v-if="
                    userDescription.isContractor == 'y' ||
                      userDescription.company_id
                  "
                >
                  <span>Is associated with company?</span>
                  <vs-switch
                    class="mt-3"
                    vs-icon-on="check_box"
                    vs-icon-off="block"
                    v-model="userDescription.hasCompanyId"
                  >
                    <span slot="on">YES</span>
                    <span slot="off">NO</span>
                  </vs-switch>
                </div>
              </div>

              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('user_type')"
                >{{ errors.first("user_type") }}</span
              >
            </vs-col> -->
            <vs-col vs-type="flex" vs-w="6" class="mb-6"> </vs-col>

            <vs-col vs-type="flex" vs-w="6" class="mb-6">
              <template
                v-if="
                  userDescription.hasCompanyId || userDescription.company_id
                "
              >
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Company:</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <AccountAutocomplete
                    :key="companySearchComponentKey"
                    class="searchbox mb-5"
                    :list="searchAccount"
                    :searchOn="'company_or_registration_no'"
                    @event-name="handleChildEvent"
                  ></AccountAutocomplete>
                  {{ companyName }}
                </div>
              </template>
            </vs-col>

            <template v-for="(language, index) in userDescription.languages">
              <vs-col vs-type="flex" vs-w="6" class="mb-6" :key="index">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Language:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <LanguageAutocomplete
                    class="searchbox"
                    :list="getLanguages"
                    :searchOn="'language'"
                    @event-name="handleLanguageSelected(index)"
                  ></LanguageAutocomplete>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="12"
                    vs-sm="12"
                    vs-xs="12"
                    ><span class="mt-2">{{ language.languages_name }}</span>
                  </vs-col>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <v-select
                    name="language_compentency"
                    label="name"
                    :options="languageCompetency"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="language.language_competency_name"
                    data-vv-as="User Compentency"
                  />
                </div>
                <feather-icon
                  class="ml-5"
                  icon="XIcon"
                  svgClasses="h-4 w-4"
                  v-on:click="removeLanguage(index)"
                />
              </vs-col>
            </template>
            <vs-col vs-type="flex" vs-w="12" class="mb-6">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="8"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-button
                  class="mt-5 mb-5"
                  color="danger"
                  @click="selectAnotherLanguage()"
                  >Add More language</vs-button
                >
              </vs-col>
            </vs-col>
          </template>

          <vs-divider class="m-5" />

          <h5 class="mb-5">Login Details</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Email Address:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                disabled
                class="w-full"
                v-model="userDescription.email"
                name="email"
                v-validate="'email|required'"
                data-vv-as="Email Address"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('email')"
              >{{ errors.first("email") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Password:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">

              <input ref="new_password" autocomplete="new-password" :type="type" name="new_password" class="w-full custom-input" v-model="userDescription.new_password" data-vv-as="Password"/>
<!-- 
              <vs-input
                ref="new_password"
                :type="type"
                class="w-full"
                name="new_password"
                v-model="userDescription.new_password"
                data-vv-as="Password"
              /> -->
            </div>
           
            <i
              style="border-left:0px;"
              @click="type = type == 'password' ? 'text' : 'password'"
              :class="[
                type == 'password'
                  ? 'vs-icon vs-input--icon-custom vs-input--icon feather icon icon-eye icon-after'
                  : 'vs-icon vs-input--icon vs-input--icon-custom feather icon icon-eye-off icon-after'
              ]"
            ></i>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Confirm Password:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                :type="confirm_type"
                class="w-full"
                name="confirm_password"
                v-model="userDescription.confirm_password"
                v-validate="'confirmed:new_password'"
                data-vv-as="Confirm Password"
              />
            </div>
            
            <i
              style="border-left:0px;"
              @click="
                confirm_type = confirm_type == 'password' ? 'text' : 'password'
              "
              :class="[
                confirm_type == 'password'
                  ? 'vs-icon vs-input--icon-custom vs-input--icon feather icon icon-eye icon-after'
                  : 'vs-icon vs-input--icon vs-input--icon-custom feather icon icon-eye-off icon-after'
              ]"
            ></i>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('confirm_password')"
              >{{ errors.first("confirm_password") }}</span
            >
          </div>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import ElomarkUserAutocomplete from "@/components/autocomplete/ElomarkUserAutocomplete.vue";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
import TimezoneAutocomplete from "@/components/autocomplete/TimezoneAutocomplete.vue";
import moduleClientManagement from "@/store/clients-management/moduleClientsManagement.js";
import moduleUserTypeManagement from "@/store/usertype-management/moduleUserTypeManagement.js";
import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";
import moduleClientUserManagement from "@/store/client-user-management/moduleClientUserManagement.js";
import LanguageAutocomplete from "@/components/autocomplete/LanguageAutocomplete.vue";
import vSelect from "vue-select";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  data() {
    return {
      counter: 0,
      languageCompetency: [],
      clientRoleTypes: [],
      type: "password",
      confirm_type: "password",
      timeZoneName: null,
      companyName: null,
      countryName: null,
      allUserTypes: [],
      allTimezones: [],
      companySearchComponentKey: 0,
      userId: null,
      elomarkManagers: [],
      elomarkRoleTypes: [],
      check_box_selected: null,
      userDescription: {
        languages: [
          {
            language_id: null,
            language_compentency: null,
            id: 0
          }
        ],
        isContractor: "n",
        first_name: null,
        surname: null,
        desk_phone: null,
        softphone: null,
        mobile_no: null,
        alternate_phone_1: null,
        alternate_phone_2: null,
        job_role: null,
        email: null,
        role: null,
        address_1: null,
        address_2: null,
        address_3: null,
        country: null,
        postcode: null,
        timezone: null,
        county: null,
        city: null,
        user_type: null,
        company_id: null,
        password_reset: null,
        confirm_password: null,
        new_password: null
      },
      configdateTimePicker: {
        enableTime: false,
        // dateFormat: "Y-m-d",
        format: "d/m/Y",
        altFormat: "d/m/Y",
        altInput: true
      }
    };
  },
  components: {
    "v-select": vSelect,
    moduleElomarkUserManagement,
    ElomarkUserAutocomplete,
    AccountAutocomplete,
    TimezoneAutocomplete,
    flatPickr,
    LanguageAutocomplete
  },
  watch: {
    "userDescription.user_type"(val) {
      if (val) {
        if (val.usertype == "Contractor") {
          this.userDescription.isContractor = "y";
        } else {
          this.userDescription.isContractor = "n";
          this.userDescription.hasCompanyId = false;
        }
      }
    }
  },
  created() {
     if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }

    if (!moduleClientUserManagement.isRegistered) {
      this.$store.registerModule(
        "clientUsersManagement",
        moduleClientUserManagement
      );
      moduleClientUserManagement.isRegistered = true;
    }

    if (!moduleUserTypeManagement.isRegistered) {
      this.$store.registerModule(
        "usertypesManagement",
        moduleUserTypeManagement
      );
      moduleUserTypeManagement.isRegistered = true;
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }

    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientsManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }

    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule("userManagement", moduleUserManagement);
      moduleUserManagement.isRegistered = true;
    }
    this.userId = this.$route.params.userId;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    let localStorageUserId = userInfo["uid"];
    this.is_client = userInfo["is_client"];
    if (this.userId !== localStorageUserId) {
      this.$router.push({
        path: "/unauthorized"
      });
    } else {
      this.init();
    }
   
  },
  mounted() {
    this.getElomarkManagers();
    this.getElomarkRoleTypes();
    this.getUserTypes();
    this.getClientRoleTypes();
    this.getLanguageCompetency();
  },
  methods: {
    removeLanguage(index) {
      this.userDescription.languages.splice(index, 1);
    },
    getLanguageCompetency() {
      this.$store
        .dispatch("elomarkUsersManagement/fetchAllLanguageCompetency")
        .then(res => {
          this.languageCompetency = res.data;
          console.log("LV", this.languageCompetency);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    selectAnotherLanguage() {
      this.userDescription.languages.push({
        id: ++this.counter,
        language_id: null,
        language_compentency: null
      });
      this.counter++;
    },
    handleLanguageSelected(index) {
      var selected_language =
        moduleElomarkUserManagement.state.selected_language;
      this.userDescription.languages[index]["language_id"] =
        selected_language.id;
      console.log(this.userDescription.languages);
    },
    getLanguages(inputValue) {
      return this.$store
        .dispatch("elomarkUsersManagement/getAllLanguages", inputValue)
        .then(response => {
          let data = moduleElomarkUserManagement.state.all_languages;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getClientRoleTypes() {
      this.$store
        .dispatch("clientUsersManagement/getClientRoleTypes")
        .then(res => {
          this.clientRoleTypes = res.data;
          console.log(this.clientRoleTypes);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getTimezones(inputValue) {
      return this.$store
        .dispatch("elomarkUsersManagement/getTimezones", inputValue)
        .then(response => {
          let data = moduleElomarkUserManagement.state.all_time_zone;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].label
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getUserTypes() {
      this.$store
        .dispatch("usertypesManagement/fetchAllTypes")
        .then(res => {
          this.allUserTypes = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    showCompanyName(accountId) {
      this.$store
        .dispatch("accountsManagement/fetchAccount", accountId)
        .then(res => {
          if (res) {
            let response = res.data;
            this.companyName = response.company_name;
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.clientDescription = true;
            return;
          }
          console.error(err);
        });
    },
    searchAccount(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data =
              moduleAccountsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    handleTimeZoneSelected() {
      var selected_time_zone =
        moduleElomarkUserManagement.state.selected_time_zone;
      this.userDescription.timezone = selected_time_zone.id;
    },
    handleChildEvent() {
      var selected_account = moduleAccountsManagement.state.accounts.datas;
      this.userDescription.company_id = selected_account[0].id;
    },
    init() {
      if (this.is_client == "n") {
        this.$store
          .dispatch("elomarkUsersManagement/fetchElomarkUser", this.userId)
          .then(res => {
            this.userDescription = res.data;
            var self = this;
            this.elomarkRoleTypes.forEach(function(ele) {
              if (ele.id == self.userDescription.roles[0].id) {
                self.userDescription.role = ele;
              }
            });
            this.elomarkManagers.forEach(function(ele) {
              if (ele.id == self.userDescription.manager) {
                self.userDescription.selected_manager =
                  ele.first_name + " " + ele.surname;
              }
            });

            this.allUserTypes.forEach(function(ele) {
              if (ele.id == self.userDescription.user_type) {
                self.userDescription.user_type = ele;
              }
            });

            if (self.userDescription.timezone) {
              this.showTimeZoneName(this.userDescription.timezone);
            }

            if (self.userDescription.country) {
              this.showCountryName(this.userDescription.country);
            }
            if (this.userDescription.company_id) {
              this.showCompanyName(this.userDescription.company_id);
            }
          })
          .catch(err => {
            console.error(err);
          });
      } else {
        this.$store
          .dispatch("clientUsersManagement/fetchClientUser", this.userId)
          .then(res => {
            this.userDescription = res.data;
            var self = this;
            this.clientRoleTypes.forEach(function(ele) {
              if (ele.id == self.userDescription.roles[0].id) {
                self.userDescription.role = ele;
              }
            });
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
    showCountryName(countryId) {
      this.$store
        .dispatch("accountsManagement/getCountry", countryId)
        .then(res => {
          this.countryName = res.data.name_1;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.accountDescription.parent = true;
            return;
          }
          console.error(err);
        });
    },
    showTimeZoneName(timezoneId) {
      this.$store
        .dispatch("elomarkUsersManagement/getTimeZone", timezoneId)
        .then(res => {
          this.timeZoneName = res.data.label;
          console.log(this.timeZoneName);
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.timeZoneName = true;
            return;
          }
          console.error(err);
        });
    },
    getCountries(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCountries", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.countries;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.userDescription.languages.forEach(element => {
            if (element.languages_uuid) {
              element.language_id = element.languages_uuid;
              element.language_competency_id = element.language_competency_uuid;
            } else {
              element.language_competency_id =
                element.language_competency_name.id;
            }
          });

          this.updateProfile();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    updateProfile() {
      console.log(this.userDescription);
      this.$store
        .dispatch("userManagement/updateProfile", this.userDescription)
        .then(res => {
          if (res.data.status == "success") {
            var jsonString = localStorage.getItem("userInfo");
            var obj = JSON.parse(jsonString);
            obj.displayName = res.data.displayName;
            localStorage.setItem("userInfo", JSON.stringify(obj));
            this.$router.push("/dashboard");
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },

    getElomarkRoleTypes() {
      this.$store
        .dispatch("elomarkUsersManagement/getElomarkRoleTypes")
        .then(res => {
          this.elomarkRoleTypes = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getElomarkManagers() {
      this.$store
        .dispatch("elomarkUsersManagement/getElomarkManagers")
        .then(res => {
          this.elomarkManagers = res.data;
          this.elomarkManagers = this.elomarkManagers.filter(function(ele) {
            ele.full_name = ele.first_name + " " + ele.surname;
            return ele;
          });
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

[dir="ltr"] .vs-input--icon.feather {
  padding: 0.9rem 2rem 0.2rem 0.2rem;
  position: relative;
}

.vs-input--icon-custom.feather {
  top: auto;
  position: absolute;

}
</style>
<style>
.flat-pick {
  padding: 0.7rem;
  font-size: 1rem;
  color: #626262;
  cursor: pointer;
}
</style>
<style scoped>
.removeButton {
  cursor: pointer;
}

.custom-input{
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem !important;
  font-size: 1rem !important;
}
</style>
